<script>
    import * as d3 from "d3";
    import * as druid from "@saehrimnir/druidjs/dist/druid.js";

    import { afterUpdate } from "svelte";

    export let scale;
    export let colorscale;
    export let value = 0;
    export let height;
    export let width;
    export let margin;
    export let ticks = 3;
    export let better = "bigger";
    export let header = false;


    $: x = scale(value);
    $: m = scale(0);


    let axis_g;
    afterUpdate(async () => {
        if (header) {
            await wait(1000)
            let [min, max] = scale.domain();
            //let gradient = druid.linspace(min, max, (width - 2 * margin) + 1).map((c, i) => [i / ((width - 2 * margin) + 1), d3.rgb(colorscale(c)).formatHex()]);

            let h_scale = d3.scaleLinear().range(scale.domain()).domain([0, 101]);
            let gradient = d3.range(101).map((c) => {
                return [
                    c, d3.rgb(colorscale(h_scale(c))).formatHex(),
                ]
            })
            const svg = d3.select(axis_g.parentNode);
            const lin_grad = svg.insert("defs", "g").append("linearGradient")
                .attr("id", "header_grad")
                .attr("x1", "0%")
                .attr("x2", "100%")
                .attr("y1", "0%")
                .attr("y2", "0%");

            lin_grad.selectAll("stop")
                .data(gradient).enter()
                    .append("stop")
                        .attr("offset", d => d[0] + "%")
                        .style("stop-color", d => d[1])
        }


        d3.select(axis_g).call(d3.axisBottom(scale).ticks(ticks))
        d3.select(axis_g)
            .attr("font-family", null)

        d3.select(axis_g).selectAll("path").attr("stroke", "#555")
        d3.select(axis_g).selectAll("line").attr("stroke", "#555")
        d3.select(axis_g).selectAll("text").attr("fill", "#555")

        // subgrid
        d3.select(axis_g).select("#subticks").selectAll("path")
            .data(scale.ticks(ticks))
            .enter().append("path")
            .merge(d3.select(axis_g).select("#subticks").selectAll("path"))
                .attr("d", (d, i) => `M ${scale(d) + .5} 0 V ${-(height - 2 * margin)}`)
                .attr("stroke-width", .5)
                .attr("stroke-dasharray", "1 1")
                .attr("stroke", "#555")
    })

    function wait(t) {
        return new Promise(res => window.setTimeout(res, t));
    }
</script>

<div>
    <svg width={width} height={height}>
        {#if header}
            <!-- <defs>
                <linearGradient id="grad" x1={margin} x2={width - 2 * margin} y1=0 y2=0>
                    {#each gradient as g}
                        <stop 
                            offset={g[0]} 
                            stop-color={g[1]}
                        />
                    {/each}                
                </linearGradient>
            </defs> -->
            <g bind:this={axis_g} transform="translate(0, {height - margin})"></g>
            <rect
                x={margin}
                y={margin}
                height={height - 2 * margin}
                width={width - 2 * margin}
                fill="url(#header_grad)"></rect>
        {:else}
            <path
                d="M {m} {height - margin} v -{height - 2 * margin} H {x} v {height - 2 * margin} Z"
                fill={colorscale(value)}
            >
                <title>{d3.format(".2f")(value)}</title>
            </path>
            <g bind:this={axis_g} transform="translate(0, {height - margin})">
                <g id="subticks"></g>
            </g>
        {/if}
        {#if better}
            <text x={better == "bigger" ? width - margin : margin} y={height - margin} fill="white" text-anchor="middle" dominant-baseline="central">*</text>
        {/if}
    </svg>
</div>